import { Dialog, DialogContent } from "@mui/material";
import MuiAvatar from "@mui/material/Avatar";
import Box from "@mui/material/Box/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import styled from "styled-components";

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`;

export const PlayersContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TeamsWrapper = styled(Box)`
  display: flex;
  flex: 1;
  transform: translateY(-28px);
  flex-direction: column;
  gap: 20px;
`;

export const Title = styled(Typography)`
  color: #000;
  font-family: "Outfit-SemiBold";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const Teams = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 20px;
`;

export const Team = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TeamHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TeamMembers = styled(Typography)`
  color: #000;
  text-align: right;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const OrganizerLabel = styled(Typography)`
  color: #000;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const TeamDescription = styled(Typography)`
  color: var(--colours-grey-500, #718096);
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const TeamTitle = styled(Typography)`
  color: #000;
  font-family: "Outfit-SemiBold";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const PlayerInfoWrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`;

export const PlayerWrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Avatar = styled(MuiAvatar)`
  width: 28px;
  height: 28px;
  background-color: var(--colours-grey-400, #a0aec0);
  color: var(--colours-primary-rkbt-black, #1d1d1d);
  text-align: center;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const PlayerName = styled(Typography)`
  color: #000;
  font-family: "NotoSans-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const BaseButton = styled(ButtonBase)`
  width: 100%;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${(props) => props.color};
`;

export const OptionWrapper = styled(Box)`
  border-radius: 12px;
  padding: 10px;
  width: 182px;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const OptionWithIconWrapper = styled(Box)`
  display: flex;
`;

export const OptionWithDividerWrapper = styled(Box)`
  display: flex;
  width: 100%;
  gap: 10px;
  flex-direction: column;
`;

export const Options = styled(Box)`
  display: flex;
  height: 30px;
  width: 100%;
  font-family: "NotoSans-Regular";
  font-size: 14px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 3px;
  background: #fff;
`;

export const RemoveOption = styled(Box)`
  display: flex;
  height: 30px;
  width: 100%;
  font-family: "NotoSans-SemiBold";
  font-size: 14px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 3px;
  background: #fff;
`;

export const ChipWrapper = styled(Box)`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const UserViewChipWrapper = styled(Box)`
  padding-right: 20px;
`;

export const ActionsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const DesktopShareWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 5px;
`;

export const UrlWrapper = styled(Box)`
  cursor: copy;
  border: 1px solid black;
  padding: 5px;
  border-radius: 5px;
  width: 100%;
`;

export const SocialMediaWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  width: 100%flex;
`;

export const DesktopShareDialog = styled(DialogContent)`
  width: 340px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  border: 0.5px solid #d9d9d9;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
`;

export const ShareActions = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DesktopShareTitle = styled(Typography)`
  color: #263238;
  text-align: center;
  font-family: "NotoSans-SemiBold";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;
